<template>
  <div class="month-selector row">
    <div class="col-2 justify-content-start">
      <ActionButton
        class-name="btn-no-style"
        @click="prevMonth">
        <i class="fas fa-chevron-left"/>
      </ActionButton>
    </div>
    <div class="col font-weight-bold month-text non-selectable-text">{{ getSelectedMonthString }}</div>
    <div class="col-2 justify-content-end">
      <ActionButton
        class-name="btn-no-style"
        @click="nextMonth">
        <i class="fas fa-chevron-right"/>
      </ActionButton>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import ActionButton from '@/components/Actions/ActionButton';

export default {
  name: 'MonthSelector',
  components: {
    ActionButton,
  },
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      selectedMonth: null,
    };
  },
  computed: {
    getSelectedMonthString() {
      const month = moment(this.selectedMonth.format('YYYY-MM-DD'));
      return `${month.format('MMMM')} ${month.year()}`;
    },
  },
  watch: {
    value: {
      handler(newVal) {
        this.selectedMonth = newVal;
      },
      immediate: true,
    },
  },
  methods: {
    nextMonth() {
      this.selectedMonth = moment(this.selectedMonth.add(1, 'month'));
      this.$emit('change', this.selectedMonth);
      this.$emit('input', this.selectedMonth);
    },
    prevMonth() {
      this.selectedMonth = moment(this.selectedMonth.add(-1, 'month'));
      this.$emit('change', this.selectedMonth);
      this.$emit('input', this.selectedMonth);
    },
  },
};
</script>

<style scoped lang="scss">
i {
  color: $secondary;
  font-size: 30px;
}

div {
  &.month-selector {
    padding: 8px 0;
    & > div {
      color: $base;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    i {
      display: flex;
    }
  }
}
.month-text {
  text-transform: capitalize;
}
.fa-chevron-right,
.fa-chevron-left {
  cursor: pointer;
}
</style>
